import { Component, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs';
import { LanguageService } from '../../services/language.service';
import { File } from '../../models/file.model';

@Component({
  selector: 'hazmatsuite-next-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
})
export class FileListComponent {

  @Input() files: File[] = []
  @Input() isEdit = false;

  @Output() togglePublicFileMode = new EventEmitter<{ id: number, refId: number, checked: boolean }>();
  @Output() deleteFile = new EventEmitter<{ id: number, refId: number }>();
  @Output() saveTitle = new EventEmitter<{ id: number, refId: number, title: string }>();
  @Output() uploadFiles = new EventEmitter<FileList>();

  public translations$ = this.languageService.translations$.pipe(
    map(translations => translations['SmartPackageResource']));

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['SmartPackageResource']);
  }

  public toggleFileMode(id: number, refId: number, event: any): void {
    this.togglePublicFileMode.next({ id, refId, checked: (<HTMLInputElement>event.target).checked });
  }

  public delete(id: number, refId: number): void {
    this.deleteFile.next({ id, refId });
  }

  public saveFilename(name: string, id: number, refId: number): void {
    this.saveTitle.next({ id, title: name, refId });
  }

  public upload(data: FileList): void {
    this.uploadFiles.next(data);
  }
}
